/* eslint-disable */
import React, { useContext, useEffect } from 'react';
import Modal from 'modules/common/components/Modal';
import { withRouter } from 'react-router-dom';
import { ModalContext } from 'App';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import withForm from 'modules/common/hoc/withForm';
import * as action from '../actions';
import * as c from '../constant';

function UpdateBarangayBusinessClearanceNumber({
  id,
  createInput,
  updating,
  formData,
  setFormData,
  updateList,
  updateBarangayClearanceNumber,
  getItem,
}) {
  const setModal = useContext(ModalContext);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleUpdateBarangayClearanceNumber = (e) => {
    e.preventDefault();
    updateBarangayClearanceNumber(id, formData, () => {
      getItem(id);
      setModal({ isOpen: false });
    });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      setFormData({
        ...formData,
        barangay_clearance_number: _.get(updateList, 'barangay_clearance_number') || ''
      })
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleUpdateBarangayClearanceNumber}>
        <div className="row">
          <div className="col-12 form-grousp">
            {createInput(
              { key: 'barangay_clearance_number', label: 'Barangay Business Clearance Number:' },
              { placeholder: 'Barangay Business Clearance' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary">
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Update`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark ml-2"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateBarangayBusinessClearanceNumber.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  updateBarangayClearanceNumber: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_BARANGAY_CLEARANCE_NUMBER) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateBarangayBusinessClearanceNumber);
